import { computed } from 'vue'
// types
import type { ComputedRef } from 'vue'
import type { FooterReviewBadgeProps } from '../types/interfaces'
// assets
import { REVIEW_BADGES } from '../images'
import type { FooterBadgeImage } from '../images'

interface FooterReviewBadgeHookOptions {
  props: FooterReviewBadgeProps
}

interface FooterReviewBadgeHookReturn {
  refImage: ComputedRef<FooterBadgeImage>
}

export const useFooterReviewBadge = ({ props }: FooterReviewBadgeHookOptions): FooterReviewBadgeHookReturn => {
  const refImage = computed<FooterBadgeImage>(() => REVIEW_BADGES[props.platform])

  return {
    refImage,
  }
}
